import React from 'react';

import { Stack, Typography, CircleIcon, makeStyles } from '@gogame/components';

const NEW = 0;
const MARK_AS_PAID = 1;
const PAYMENT_CANCELLED = 2;
const DELETED = 3;
const REJECTED = 4;
const APPROVED = 5;
const DRAFT = 6;

const useStyles = makeStyles((theme) => ({
  root: {
    color: ({ color }) => theme?.palette?.[color]?.main,
  },
}));

export const getColor = (id) => {
  switch (id) {
    case NEW:
    case APPROVED:
      return 'success';
    case MARK_AS_PAID:
      return 'payment';
    case PAYMENT_CANCELLED:
    case DELETED:
      return 'inactive';
    case REJECTED:
      return 'error';
    case DRAFT:
      return 'draft';
  }
};

const InvoiceStatus = ({ id, children }) => {
  const classes = useStyles({ color: getColor(id) });
  return (
    <Stack spacing={1} direction={'row'} alignItems={'center'}>
      <CircleIcon sx={{ fontSize: 14 }} className={classes.root} />
      <Typography paragraph={false}> {children}</Typography>
    </Stack>
  );
};

export default InvoiceStatus;
